import React, {useState, useEffect} from 'react';
import { Box,  Typography} from '@mui/material';
import '../../css/App.css';

function ReferralPathQuestions(props)
{
const [allQuestions,setAllQuestions] = useState([])
const [questions, setQuestions]=useState(props.questions)

    useEffect(()=>{
    let questionAccumulator=[]
    if (questions !== undefined)
        {
        let questionList=Object.keys(questions)
        questionList.forEach((question)=>{
            let questionWithSpaces=question.replaceAll("_"," ")
            let questionString = `${questionWithSpaces}  : ${questions[question] } `
            questionAccumulator.push(questionString)})
            setAllQuestions(questionAccumulator)
        }
        }, [])


 let content=allQuestions.map((question,index)=>{return(<Typography key={index}>{question}<br></br><br></br></Typography>)})

return(
    <Box className="outcomeBox">
        <Typography variant='h6'>
            {props.heading}
        </Typography>
       
       {content}

    </Box>
)
}
export default ReferralPathQuestions